export default __webpack_public_path__ + "static/media/bg-contact.7573d0cf.jpg";